import React from "react";

const Card = ({children, className}) => (

    <div className={`${className} shadow-lg bg-white text-gray-800 w-full h-full rounded-lg p-5 md:p-8`}>
        {children}
    </div>
)
export default Card